import React from 'react';
import { connect } from 'react-redux';
import {
  selectCardInstallments,
  selectDeviceType,
  selectIsSaveCardChecked,
} from '../../redux/selectors';
import { StoreState } from '../../types/ReduxMisc';
import CashierPaymentsWidget from './controller';

const mapStateToProps = (state: StoreState) => ({
  isSaveCardChecked: selectIsSaveCardChecked(state),
  cardInstallments: selectCardInstallments(state),
  deviceType: selectDeviceType(state),
});

const mapDispatchToProps = {};

type ComponentProps = React.ComponentProps<typeof CashierPaymentsWidget>;
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
type OwnProps = Omit<ComponentProps, keyof (StateProps & DispatchProps)>;

export const CashierPaymentsWidgetConnect = connect<
  StateProps,
  DispatchProps,
  OwnProps
>(
  mapStateToProps,
  mapDispatchToProps
)(CashierPaymentsWidget);
